import React from 'react';
import FontAwesome from 'react-fontawesome';
import { withTranslation } from 'react-i18next';
import ui from '../common/services/ui';

const ProfileMenu = ({ user, parent, t }) => {

    return <div>
        <div className='circle-icon bg-light avatar'>
            {user.userImpersonation ? <FontAwesome name='user-secret' className='text-danger' /> :
                ui.getAvatarName(parent.firstName, parent.lastName)}
        </div>
        <span>{`${parent.firstName}`} <FontAwesome name='angle-down' /></span>
    </div>;
};

export default withTranslation()(ProfileMenu);